import typeCheckingStore from "data/util/typeCheckingStore";
import { ReduceStore } from "flux/utils";
import PropTypes from "prop-types";
import Dispatcher from "Dispatcher";
import UserActions from "data/UserActions";
import {
    concatSlice,
    newSlice,
    sliceTypeBuilder,
    toSlice,
} from "data/slices";

export class OrganizationsStore extends ReduceStore {

    getInitialState() {
        return newSlice();
    }

    reduce(state, action) {
        switch (action.type) {
            case UserActions.LOADED: {
                const u = action.user;
                return concatSlice(
                    state,
                    toSlice(u.organizations, "key", o => ({
                        key: o.key,
                        name: o.name,
                        accessible: true,
                    })),
                    toSlice(u.extraDescendantOrgs, "key"),
                );
            }

            default:
                return state;
        }
    }

    getKeyLookup() {
        return this.getState().byKey;
    }

}

OrganizationsStore.stateTypes = sliceTypeBuilder(PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
}));

const organizationsStore = typeCheckingStore(new OrganizationsStore(Dispatcher));

export default organizationsStore;



// WEBPACK FOOTER //
// ./app/data/organizationsStore.js